import React, { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
  DialogTrigger,
} from './ui/dialog';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { toast } from '../hooks/use-toast';
import api from '../utils/api';

const emptyForm = { name: '', whatsapp: '', email: '', company: '' };

const AddGuestDialog = ({ eventId, onGuestAdded, trigger }) => {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState(emptyForm);
  const [saving, setSaving] = useState(false);

  const update = (field, value) => setForm((prev) => ({ ...prev, [field]: value }));

  const handleSave = async () => {
    if (!form.name.trim()) {
      toast({ title: 'Guest name is required', variant: 'destructive' });
      return;
    }
    setSaving(true);
    try {
      await api.post(`/events/${eventId}/guests`, {
        name: form.name,
        phone: form.whatsapp,
        email: form.email,
        company: form.company,
      });
      toast({ title: 'Guest added', description: `${form.name} has been added.` });
      setForm(emptyForm);
      setOpen(false);
      onGuestAdded?.();
    } catch (error) {
      if (error?.error?.code === 'INSUFFICIENT_CREDITS') {
        toast({
          title: 'Out of credits',
          description: 'You need more credits to add another guest.',
          variant: 'destructive',
        });
      } else {
        toast({
          title: 'Failed to add guest',
          description: error?.error?.message || 'Please try again.',
          variant: 'destructive',
        });
      }
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      {trigger && <DialogTrigger asChild>{trigger}</DialogTrigger>}
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Add Guest</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <div>
            <Label htmlFor="guest-name">Guest Name *</Label>
            <Input
              id="guest-name"
              placeholder="Enter guest name"
              value={form.name}
              onChange={(e) => update('name', e.target.value)}
            />
          </div>
          <div>
            <Label htmlFor="guest-whatsapp">WhatsApp Number</Label>
            <Input
              id="guest-whatsapp"
              placeholder="+91 98765 43210"
              value={form.whatsapp}
              onChange={(e) => update('whatsapp', e.target.value)}
            />
          </div>
          <div>
            <Label htmlFor="guest-email">Email</Label>
            <Input
              id="guest-email"
              type="email"
              placeholder="guest@example.com"
              value={form.email}
              onChange={(e) => update('email', e.target.value)}
            />
          </div>
          <div>
            <Label htmlFor="guest-company">Company / Category</Label>
            <Input
              id="guest-company"
              placeholder="e.g. Project Manager or Club Name"
              value={form.company}
              onChange={(e) => update('company', e.target.value)}
            />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => setOpen(false)}>
            Cancel
          </Button>
          <Button className="bg-orange-500 hover:bg-orange-600" onClick={handleSave} disabled={saving}>
            {saving ? 'Saving...' : 'Save'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default AddGuestDialog;
